<template>
  <div class="copyright-card">
    <el-row type="flex" align="bottom" justify="space-between">
      <el-col :span="9">
        <copyrightInformation></copyrightInformation>
      </el-col>
      <el-col :span="12">
        <img
          class="copyright-img"
          :src="`${
            setting.backgroundImage2 || '@/assets/images/reserved-bg.png'
          }`"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import copyrightInformation from "../copyrightInformation";
import { getSetting } from "@/api/parent/setting";
export default {
  components: { copyrightInformation },
  data() {
    return {
      setting: {},
    };
  },
  created() {
    this.getSetting();
  },
  methods: {
    getSetting() {
      getSetting().then((v) => {
        this.setting = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.copyright-card {
  padding-top: 2.5rem;
  padding-bottom: 1.0625rem;
  padding-left: 1.25rem;
}
.copyright-img{
   display: block;
   margin-left: auto;
   width: 60%;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .copyright-img {
    width: 100%;
  }
}
</style>